import { useRouter } from '@/hooks/useRouter'
import { Button } from '@/components/ui/button'
import { Link } from 'react-router-dom'
import { NavBar } from '../nav-bar'

export function LeaveScreen({ setIsMeetingLeft }) {
  const router = useRouter()

  return (
    <>
      <NavBar />
      <div className="bg-background h-screen flex flex-col flex-1 items-center justify-center">
        <h1 className="dark:text-white text-4xl">You left the debate!</h1>
        <div className="flex space-x-6 mt-12">
          <Link to="/">
            <Button variant="outline" className="dark:bg-white dark:text-black">
              Home
            </Button>
          </Link>
          <Button
            variant="outline"
            className="text-white border-none dark:border hover:text-white bg-indigo-500 hover:bg-indigo-600"
            onClick={() => {
              setIsMeetingLeft(false)
              router.refresh()
            }}
          >
            Rejoin the Meeting
          </Button>
        </div>
      </div>
    </>
  )
}
